var map = {
	"./elephant_ui_disappointed": 1920,
	"./elephant_ui_disappointed.svg": 1920,
	"./glitch-preview": 1921,
	"./glitch-preview.png": 1921,
	"./logo_warn_glitch": 1300,
	"./logo_warn_glitch.svg": 1300,
	"./mbstobon-ui-0": 1903,
	"./mbstobon-ui-0.png": 1903,
	"./mbstobon-ui-1": 1904,
	"./mbstobon-ui-1.png": 1904,
	"./mbstobon-ui-2": 1905,
	"./mbstobon-ui-2.png": 1905,
	"./mbstobon-ui-3": 1922,
	"./mbstobon-ui-3.png": 1922,
	"./wave-drawer": 1923,
	"./wave-drawer-glitched": 1924,
	"./wave-drawer-glitched.png": 1924,
	"./wave-drawer.png": 1923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2075;